import type {
  ServiceVehicleCreateApiData,
  ServiceVehicleCreateApiResponses,
  ServiceVehicleDeleteApiData,
  ServiceVehicleDeleteApiResponses,
  ServiceVehicleGetApiData,
  ServiceVehicleGetApiResponses,
  ServiceVehicleListApiData,
  ServiceVehicleListApiResponses,
  ServiceVehiclePatchApiData,
  ServiceVehiclePatchApiResponses,
  ServiceWorkerVehicleCreateApiData,
  ServiceWorkerVehicleCreateApiResponses,
  ServiceWorkerVehicleDeleteApiData,
  ServiceWorkerVehicleDeleteApiResponses,
  ServiceWorkerVehicleListApiData,
  ServiceWorkerVehicleListApiResponses,
  VehicleCargoCapacityCreateApiData,
  VehicleCargoCapacityCreateApiResponses,
  VehicleCargoCapacityDeleteApiData,
  VehicleCargoCapacityDeleteApiResponses,
  VehicleCargoCapacityGetApiData,
  VehicleCargoCapacityGetApiResponses,
  VehicleCargoCapacityListApiData,
  VehicleCargoCapacityListApiResponses,
  VehicleCargoCapacityPatchApiData,
  VehicleCargoCapacityPatchApiResponses
} from '@navio/nsdk';

import { apiUrl, dataEndpoint, responseEndpoint } from '../defineResource';

export const getServiceVehicleUrls = {
  getPaginatedServiceVehicles: dataEndpoint<ServiceVehicleListApiData, ServiceVehicleListApiResponses>({
    getUrl: (queryParams) => apiUrl('service-vehicles/', queryParams)
  }),
  getServiceVehicle: dataEndpoint<ServiceVehicleGetApiData, ServiceVehicleGetApiResponses>({
    getUrl: ({ pk }) => apiUrl(`service-vehicles/${pk}/`)
  }),
  postServiceVehicle: responseEndpoint<ServiceVehicleCreateApiData, ServiceVehicleCreateApiResponses>({
    getUrl: () => apiUrl('service-vehicles/'),
    getBody: (data) => data
  }),
  patchServiceVehicle: responseEndpoint<ServiceVehiclePatchApiData, ServiceVehiclePatchApiResponses>({
    getUrl: ({ pk }) => apiUrl(`service-vehicles/${pk}/`),
    getBody: ({ pk: _, ...data }) => data
  }),
  deleteServiceVehicle: dataEndpoint<ServiceVehicleDeleteApiData, ServiceVehicleDeleteApiResponses>({
    getUrl: ({ pk }) => apiUrl(`service-vehicles/${pk}/`)
  }),
  getPaginatedVehicleCargoCapacities: dataEndpoint<
    VehicleCargoCapacityListApiData,
    VehicleCargoCapacityListApiResponses
  >({
    getUrl: (queryParams) => apiUrl('vehicle-cargo-capacities/', queryParams)
  }),
  getVehicleCargoCapacity: dataEndpoint<VehicleCargoCapacityGetApiData, VehicleCargoCapacityGetApiResponses>({
    getUrl: ({ vehicleCargoCapacityId }) => apiUrl(`vehicle-cargo-capacities/${vehicleCargoCapacityId}/`)
  }),
  postVehicleCargoCapacity: responseEndpoint<VehicleCargoCapacityCreateApiData, VehicleCargoCapacityCreateApiResponses>(
    {
      getUrl: () => apiUrl('vehicle-cargo-capacities/'),
      getBody: (data) => data
    }
  ),
  patchVehicleCargoCapacity: responseEndpoint<VehicleCargoCapacityPatchApiData, VehicleCargoCapacityPatchApiResponses>({
    getUrl: ({ vehicleCargoCapacityId }) => apiUrl(`vehicle-cargo-capacities/${vehicleCargoCapacityId}/`),
    getBody: (data) => data
  }),
  deleteVehicleCargoCapacity: dataEndpoint<VehicleCargoCapacityDeleteApiData, VehicleCargoCapacityDeleteApiResponses>({
    getUrl: ({ vehicleCargoCapacityId }) => apiUrl(`vehicle-cargo-capacities/${vehicleCargoCapacityId}/`)
  }),
  getPaginatedServiceWorkerVehicles: dataEndpoint<
    ServiceWorkerVehicleListApiData,
    ServiceWorkerVehicleListApiResponses
  >({
    getUrl: (queryParams) => apiUrl('service-worker-vehicles/', queryParams)
  }),
  postServiceWorkerVehicle: responseEndpoint<ServiceWorkerVehicleCreateApiData, ServiceWorkerVehicleCreateApiResponses>(
    {
      getUrl: () => apiUrl('service-worker-vehicles/'),
      getBody: (data) => data
    }
  ),
  deleteServiceWorkerVehicle: dataEndpoint<ServiceWorkerVehicleDeleteApiData, ServiceWorkerVehicleDeleteApiResponses>({
    getUrl: ({ serviceWorkerVehicleId }) => apiUrl(`service-worker-vehicles/${serviceWorkerVehicleId}/`)
  })
};
